<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Produtividade — Geral: Listagem e exibição
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        |  os períodos de produtividade e
        strong  abrir
        |  o resumo geral de um período.

      .toast.toast-primary
        | Exige as permissões
        strong  Produtividade → Geral → Listar
        |  e
        strong  Produtividade → Geral → Exibir
        | .

      h5.h5 1. Abrir Produtividade
      ol
        li No menu lateral, clique em
          strong  Produtividade
          | .
      p Você chega à listagem de períodos (referências mensais).

      h5.h5 2. Listagem
      p
        | A tabela mostra
        strong  ID
        | ,
        strong  Referência
        |  (ano-mês),
        strong  Média total
        |  e se o período está
        strong  Encerrado
        |  (Sim/Não).
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de períodos de produtividade")
      ol
        li Use a paginação no rodapé se houver várias páginas.
        li Clique em uma
          strong  linha
          |  (ou na seta à direita) para abrir o período.

      h5.h5 3. Exibir o período (Geral)
      p
        | O cabeçalho mostra a referência, a média total e o botão
        strong  Imprimir
        |  (abre o relatório em nova aba). Abaixo ficam as médias
        |  (individual bruto, perdidos, líquido, extraordinário, coletivo)
        |  e se o período está encerrado.
      figure.manual-figure
        img(:src="imgShow" alt="Exibição do período Geral com resumos")
      p
        | Em seguida aparecem as tabelas de resumo por equipe
        |  (
        strong  Resumo Geral
        | ,
        strong  Equipe Externa
        | ,
        strong  Transição
        | ,
        strong  Interna
        | , conforme houver dados). Clique na linha de um fiscal
        |  para abrir o resumo individual (próximo manual).

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/26-produtividade-geral-lista.png"),
      imgShow: require("@/assets/manuais/26a-produtividade-geral-show.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
